/** OPEX ön filtre — öneri olarak ilerletmeme nedenleri (HTML 2) */
export const OPEX_REJECT_REASONS = [
  'ÜCRET, ÖDÜL, CEZA',
  'PERSONEL POLİTİKASI',
  'MEVZUAT / YASAL ZORUNLULUK KAPSAMINDA YAPILMASI GEREKEN',
  'DÖF AÇILMALI',
  'İYİLEŞTİRME İÇERMİYOR',
  'GÖREV TANIMI / STANDART İŞ GEREĞİ ZATEN YAPILMASI GEREKEN',
  'AYNI KONU DAHA ÖNCE ÖNERİLMİŞ / KAYITLI (MÜKERRER)',
  'TALEP',
  'İHBAR / ŞİKAYET',
  'ARIZA/UYGUNSUZLUK BİLDİRİMİ',
  'ÖNERİ BİLGİSİ EKSİK',
  'RAMAK KALA / TEHLİKELİ DURUM BİLDİRİMİ',
]

export const OPEX_DECISION = {
  FORWARD: 'forward',
  REJECT: 'reject',
}

export const RAMAK_KALA_REASON = 'RAMAK KALA / TEHLİKELİ DURUM BİLDİRİMİ'
